import { forget, session } from './auth';
import eventsTracking from './eventsTracking';

export const logout = async (noReload = false) => {
  eventsTracking.account.logout();
  session.clear();
  await forget();
  if (!noReload) window.location.reload();
};
